export default "__VITE_ASSET__CUaWcSPA__"